import { useMutation } from "@tanstack/react-query";

import { queryClient } from "@config/queryClient";
import useMeetingStore from "@store/useMeetingStore";
import usePlatformStore from "@store/usePlatformStore";
import peopleService from "@services/people.service";
import { useBugsnagErrorHandler } from "@hooks/useBugsnagErrorHandler";
import { ERROR_STRINGS } from "@config/messages";
import { IPeople } from "@interfaces/people.interface";
import { MEETING_QUERY_KEY } from "@config/query";

export function useActivatePerson() {
  const { notifyBugsnag } = useBugsnagErrorHandler();
  const { itemId } = usePlatformStore();
  const { meetingId } = useMeetingStore();

  return useMutation({
    mutationFn: (person: IPeople) => {
      return peopleService.activatePerson(person.id, meetingId);
    },
    onMutate: async (person: IPeople) => {
      const previousData = queryClient.getQueryData<any>([MEETING_QUERY_KEY, itemId]);

      queryClient.setQueryData([MEETING_QUERY_KEY, itemId], (old: any) => {
        if (!Array.isArray(old?.meeting?.people)) return old;

        return {
          ...old,
          meeting: {
            ...old.meeting,
            people: old.meeting.people.map((p: IPeople) =>
              p.id === person.id ? { ...p, is_suggested: false } : p
            ),
          },
        };
      });

      return { previousData };
    },
    onError: (error, _person, context) => {
      notifyBugsnag(error, ERROR_STRINGS.ACTIVATE_PERSON);

      if (context?.previousData) {
        queryClient.setQueryData([MEETING_QUERY_KEY, itemId], context.previousData);
      }
    },
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: [MEETING_QUERY_KEY, itemId] });
    },
    onSuccess: () => {},
  });
}
